document.addEventListener("DOMContentLoaded", () => {
  // Style select handler
  const styleSelect = document.querySelector('[name="options[Style]"]');
  const styleSelectOptions = styleSelect.querySelectorAll("option");
  const uploadContainer = document.querySelector(".product-form__upload");
  const uploadField = uploadContainer.querySelector('[type="file"]');
  const productFormButtons = document.querySelector(".product-form__buttons");
  const clearUpload = uploadContainer.querySelector(".button--clear");
  const customValue = "Own Artwork";

  const enableDisableSubmit = (state) => {
    const action = state ? "add" : "remove";

    productFormButtons.classList[action]("is-disabled");
  }

  const showHideUpload = (selectedStyle) => {
    if (selectedStyle === customValue) {
      enableDisableSubmit(true);
      uploadContainer.classList.remove("hidden");
    } else {
      enableDisableSubmit(false);
      uploadContainer.classList.add("hidden");
    }
  }

  const setFieldRequired = (state) => {
    uploadField.required = state;
  }

  const resetUploadField = () => {
    enableDisableSubmit(true);
    clearUpload.click();
    setFieldRequired(false);
  }

  const bindUpload = () => {
    styleSelect.addEventListener("change", (event) => {
      const selectedStyle = event.target.value;
      showHideUpload(selectedStyle);

      if (selectedStyle !== customValue) {
        resetUploadField();
        enableDisableSubmit(false);
      } else {
        setFieldRequired(true);
      }
    });

    uploadField.addEventListener("change", (event) => {

      if (event.target.files.length > 0) {
        enableDisableSubmit(false);
      } else {
        enableDisableSubmit(true);
      }
    });

    clearUpload.addEventListener("click", () => {
      uploadField.files = new DataTransfer().files
      enableDisableSubmit(true);
    });
  };

  styleSelectOptions.forEach((option) => {
    const style = option.value;

    if (style !== customValue) {
      clearUpload.click();
      uploadField.required = false;
      return;
    }

    uploadField.required = true;

    if (option.selected) {
      showHideUpload(customValue);
    }

    bindUpload();
  });
});
